module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/canva/canva-promo-poster-0bf676441e017cef913595adb4261634.jpg";